@if (isMatMenu) {
  <button mat-menu-item
          data-test="dms-openUploadZipFolderModal-button"
          [matTooltip]="tooltipText | translate"
          [matTooltipDisabled]="!iconOnly"
          (click)="openUploadZipFolderModal()">
    <i [hidden]="labelOnly" class="icon fa-fw fas fa-upload"></i>
    <label [hidden]="iconOnly" class="mb-0">
      {{ title }}
    </label>
  </button>
} @else {
  <sk-button [appearance]="iconOnly ? 'icon' : 'text'"
             data-test="dms-openUploadZipFolderModal-button"
             [color]="iconOnly ? 'unspecified' : 'primary'"
             [label]="!iconOnly ? title : ''"
             [ngClass]="btnClass"
             [matTooltip]="tooltipText | translate"
             [matTooltipDisabled]="isMatMenu"
             (click)="openUploadZipFolderModal()">
    @if (iconOnly) {
      <i [hidden]="labelOnly" class="icon fa-fw fas fa-upload"></i>
    } @else {
      <ng-template buttonPrefix>
        <i [hidden]="labelOnly" class="icon fa-fw fas fa-upload"></i>
      </ng-template>
    }
  </sk-button>
}
